<template>
  <v-card v-if="this.$mmconfig.allowUserLogin">
    <v-card-title class="headline grey lighten-2">
      {{ $t('login.login') }}
    </v-card-title>

    <v-card-text>
      <div class="w-full max-w-xs mx-auto">
        <form @submit.prevent="login()" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <v-text-field
            v-model="form.username"
            :label="$t('login.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.password"
            :label="$t('login.password')"
            type="password"
            required
          ></v-text-field>
          <v-row
            align="center"
            justify="space-around"
          >
            <v-btn
              type="submit"
              color="info">
              {{ $t('login.signIn') }}
            </v-btn>
          </v-row>
        </form>
        <v-row
          align="center"
          justify="space-around"
        >
          <a v-if="this.$mmconfig.allowUserRegistration" href="#" @click="$emit('switchTab', 'registration')">
            {{ $t('login.createAccount') }}
          </a>
          <a v-if="this.$mmconfig.allowPasswordReset" href="#" @click="$emit('switchTab', 'resetPassword')">
            {{ $t('login.forgotPassword') }}
          </a>
        </v-row>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="$emit('close')"
      >
        {{ $t('base.close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        form: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      async login() {
        return new Promise((resolve) => {
          axios.post(`${window.mmconfig.siteUri}/wp-json/jwt-auth/v1/token`, this.form).then((response) => {
            if(response.data.success === true) {
              this.$store.dispatch('login', response.data.data)
              this.$store.dispatch('message', { content: this.$i18n.t('login.loginSuccess'), color: 'success' })
            } else {
              this.$store.dispatch('message', { content: this.$i18n.t('login.loginFailure'), color: 'error' })
            }
            resolve()
          }).catch(() => {
            this.$store.dispatch('message', { content: this.$i18n.t('login.loginFailure'), color: 'error' })
            this.$emit('close')
          })
        this.$emit('close')
        })
      },
    }
  }
</script>